module.exports = __webpack_public_path__ + "static/media/perla_ramos_1.77e67540.jpg";